import useAppStore from '@/store/useAppStore'
import { ActivityTypeUtil, NotificationItem, SocketMessage } from '@/types/notification'
import { TopicType } from '@/utils/constants'

interface SocketVariableData {
  topicApplication?: number
  topicType?: number
  visibility?: number
  extraData?: Record<string, any>[]
}
const useNotificationStorageHook = () => {
  const { addSocketMessage } = useAppStore()

  const parseVariableDataText = (text: string) => {
    let result: SocketVariableData = {}
    if (text?.length > 0) {
      // Extracting varData and parsing separately, because split by comma can break
      // because of JSON string inside varData

      let updated = text
      let varDataIndex = text.indexOf(',varData=')
      const varDataSubStr = text.substring(varDataIndex)
      updated = text.replace(varDataSubStr, '')
      let variableData: Record<string, any>[] = []

      if (varDataSubStr.length > 0) {
        const variableDataParts = varDataSubStr.split('=')
        if (variableDataParts.length > 1) {
          const varDataValue = variableDataParts[1]
          if (varDataValue?.length > 0 && varDataValue?.startsWith('[')) {
            variableData = JSON.parse(varDataValue)
          }
        }
      }
      let components = updated.split(',')
      const mappedObject = components.reduce(
        (acc: Record<string, string | null>, item: string) => {
          const parts = item.split('=')
          if (parts.length > 0) {
            let value: string | null = null
            const keyName = parts[0]
            if (parts.length > 1) {
              value = parts[1]
            }
            acc[keyName] = value
          }
          return acc
        },
        {} as Record<string, string | null>,
      )

      result = {
        ...mappedObject,
        extraData: variableData,
      }
    }
    return result
  }

  const addMessage = (message: SocketMessage) => {
    const varDataObject = parseVariableDataText(message?.eventData?.variableData || '')
    const item: NotificationItem = {
      ...message.eventData,
      isRead: false,
      topicApplication: varDataObject?.topicApplication || 20,
      // `100` isn't a real TopicType (see utils/constants) — it silently broke the
      // "click to view" link (TopicPreviewBase treats an unknown topicType as
      // missing and bounces to `/`). Albums are by far the most common target for
      // likes/comments, so that's the safest fallback when variableData omits it.
      topicType: varDataObject?.topicType || TopicType.ALBUM,
      visibility: varDataObject?.visibility || 1,
      extraData: varDataObject.extraData || [],
    }
    if (ActivityTypeUtil.isSocketEventSupported(item.eventType)) {
      addSocketMessage(item)
    }
  }

  return { addMessage }
}

export default useNotificationStorageHook
